import "../../assets/css/mainMenu.css";
import { useLocation, useNavigate } from "react-router-dom";
import close from "../../assets/icons/close.svg";
import eye from "../../assets/icons/view.svg"; // Added for view action (adjust path if needed)
import ArrowDown from "../../assets/icons2/ArrowDown.svg";
import ArrowUp from "../../assets/icons2/ArrowUp.svg";
import Loader from "../../Components/LoaderAndSpinner/Loader";
import Pagination from "../../Components/Pagination/Pagination";
import { useDispatch } from "react-redux";
import search2 from "../../assets/icons/search2.svg";
import { ToastContainer, toast } from "react-toastify";

import React, { useState, useEffect } from "react";
import { setNotificationCount } from "../../Redux/User/UserSlice";
import fetchWrapper from "../../AuthMiddleware/FetchWrapper";

const Notification = () => {
  const [notifications, setNotifications] = useState([]);
  const [notificationUserIds, setNotificationUserIds] = useState([]);
  const [users, setUsers] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedNotification, setSelectedNotification] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [sortBy, setSortBy] = useState({
    field: "created_at",
    order: "desc",
  });
  const [totalItems, setTotalItems] = useState(0);
  const [loading, setLoading] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [search, setSearch] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const location = useLocation();
  const startIndex = (currentPage - 1) * pageSize + 1;
  const endIndex = Math.min(currentPage * pageSize, totalItems);

  const toggleDropdown = () => setIsDropdownOpen(!isDropdownOpen);
  const handleSearchChange = (e) => setSearchQuery(e.target.value);

  const filteredUsers = users.filter((user) =>
    user.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  // Fetch notification users
  const fetchNotificationUsers = async () => {
    const token = sessionStorage.getItem("jwt_token");
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_API_URL1}/api/v1/notification/getNotificationUsers`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = await response.json();
      if (!response.ok) {
        if (response.status === 401 || response.status === 403) {
          navigate("/unauthorized");
        }
        throw new Error(data.message || "Failed to fetch notification users");
      }
      const ids = data?.notification_users?.map((nu) =>
        String(nu.notification_id)
      );
      setNotificationUserIds(ids);
    } catch (error) {
      console.error(
        "Failed to fetch notification users:",
        error.message || error
      );
    }
  };

  // Fetch notifications
  const fetchNotifications = async () => {
    const token = sessionStorage.getItem("jwt_token");
    try {
      setLoading(true);
      const payload = {};
      if (selectedUserId) payload.user_id = selectedUserId;
      if (search) payload.search = search;
      const response = await fetch(
        `${process.env.REACT_APP_BASE_API_URL1}/api/v1/notification/paginateNotifications?page=${currentPage}&limit=${pageSize}&sortBy=${sortBy.field}&order=${sortBy.order}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(payload),
        }
      );
      const data = await response.json();
      if (!response.ok) {
        if (response?.status === 401 || response.status === 403) {
          navigate("/unauthorized");
        }
        throw new Error(data.message || "Failed to fetch notifications");
      }

      const mappedRows = data?.notifications?.map((notification, index) => {
        const user = users?.find((u) => u._id === notification.user_id);
        const date = new Date(notification.date_time);
        const formattedDateTime = date?.toLocaleString("en-US", {
          hour: "numeric",
          minute: "numeric",
          second: "numeric",
          hour12: true,
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        });
        const isUnread = !notificationUserIds?.includes(
          String(notification._id)
        );
        // Truncate notification message for table
        const shortMessage =
          notification.notification.split("\nBefore")[0] ||
          notification.notification;

        return {
          _id: notification._id,
          index: index + 1 + (currentPage - 1) * pageSize,
          date_time: formattedDateTime,
          module_name: notification.module_name,
          notification: shortMessage, // Use truncated message
          fullNotification: notification.notification, // Store full message for modal
          user_id: user ? user.name : "-",
          isUnread,
        };
      });

      setNotifications(mappedRows);
      setTotalPages(data.totalPages);
      setCurrentPage(data.currentPage);
      setTotalItems(data.totalItems);
    } catch (error) {
      console.error("Failed to fetch notifications:", error.message || error);
    } finally {
      setLoading(false);
    }
  };

  // Fetch users
  const fetchUsers = async () => {
    const token = sessionStorage.getItem("jwt_token");
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_API_URL1}/api/v1/user/getall`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = await response.json();
      if (!response.ok) {
        if (response.status === 401 || response.status === 403) {
          navigate("/unauthorized");
        }
        throw new Error(data.message || "Failed to fetch users");
      }
      setUsers(data.users);
    } catch (error) {
      console.error("Failed to fetch users:", error.message || error);
    }
  };

  // Update notification count
  // const getNotificationCount = async () => {
  //   const token = sessionStorage.getItem("jwt_token");
  //   try {
  //     const response = await fetch(
  //       `${process.env.REACT_APP_BASE_API_URL1}/api/v1/notification/countUnreadNotifications`,
  //       {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${token}`,
  //         },
  //       }
  //     );
  //     const data = await response.json();
  //     if (!response.ok) {
  //       if (response.status === 401 || response.status === 403) {
  //         navigate("/unauthorized");
  //       }
  //       throw new Error(data.message || "Failed to fetch notification count");
  //     }
  //     dispatch(setNotificationCount(data));
  //   } catch (error) {
  //     console.error(
  //       "Failed to fetch notification count:",
  //       error.message || error
  //     );
  //   }
  // };

  const readAllNotifications = async () => {
    const token = sessionStorage.getItem("jwt_token");
    if (!token) {
      console.error("No JWT token found in sessionStorage");
      return;
    }
    try {
      setLoading(true);
      const payload = selectedUserId ? { user_id: selectedUserId } : {};
      const response = await fetch(
        `${process.env.REACT_APP_BASE_API_URL1}/api/v1/notification/readAllNotifications`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(payload),
        }
      );
      const data = await response.json();
      toast.success(data.message || "All notifications marked as read");
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    } catch (error) {
      console.error("Failed to mark all notifications as read:", error.message);
    } finally {
      setLoading(false);
    }
  };
  // Mark notification as read
  const addNotificationUser = async (id) => {
    const token = sessionStorage.getItem("jwt_token");
    try {
      setLoading(true);
      const response = await fetch(
        `${process.env.REACT_APP_BASE_API_URL1}/api/v1/notification/createNotificationUser`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ id }),
        }
      );
      const data = await response.json();
      if (!response.ok) {
        if (response.status === 401 || response.status === 403) {
          navigate("/unauthorized");
        }
        throw new Error(data.message || "Failed to mark notification as read");
      }
      // await getNotificationCount();
      await fetchNotificationUsers();
    } catch (error) {
      console.error("Failed to add notification user:", error.message || error);
    } finally {
      setLoading(false);
    }
  };

  // Handle view click
  const handleViewClick = async (notification) => {
    const token = sessionStorage.getItem("jwt_token");
    try {
      setLoading(true);
      const response = await fetch(
        `${process.env.REACT_APP_BASE_API_URL1}/api/v1/notification/getNotification`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ id: notification._id }),
        }
      );
      const data = await response.json();
      if (!response.ok) {
        if (response.status === 401 || response.status === 403) {
          navigate("/unauthorized");
        }
        throw new Error(data.message || "Failed to view notification");
      }
      if (data?.data) {
        const user = users.find((u) => u._id === data.data.user_id);
        const date = new Date(data.data.date_time);
        const formattedDateTime = date.toLocaleString("en-US", {
          hour: "numeric",
          minute: "numeric",
          second: "numeric",
          hour12: true,
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        });
        setSelectedNotification({
          ...data.data,
          user_id: user ? user.name : "-",
          date_time: formattedDateTime,
        });
        setIsModalOpen(true);
      }
      await addNotificationUser(notification._id);
    } catch (error) {
      console.error("Failed to view notification:", error.message || error);
    } finally {
      setLoading(false);
    }
  };

  // Handle sort change
  const handleSortChange = (field) => {
    setSortBy((prevSort) => ({
      field,
      order:
        prevSort.field === field && prevSort.order === "asc" ? "desc" : "asc",
    }));
    setCurrentPage(1);
  };

  // Handle page change
  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  // Handle page size change
  const handlePageSizeChange = (size) => {
    setPageSize(size);
    setCurrentPage(1);
  };

  const handleUserSelect = (userId) => {
    setSelectedUserId(userId);
    setCurrentPage(1);
    navigate(`/notifications${userId ? `?user_id=${userId}` : ""}`);
  };
  // Initial data fetch
  useEffect(() => {
    const init = async () => {
      await fetchNotificationUsers();
      // await getNotificationCount();
      await fetchUsers();
    };
    init();
  }, []);

  useEffect(() => {
    fetchNotifications();
  }, [
    users,
    notificationUserIds,
    currentPage,
    pageSize,
    sortBy,
    selectedUserId,
  ]);
  // Recursive pretty printer
  const prettyPrint = (obj, indent = 2) => {
    if (typeof obj === "string") {
      // Try to parse nested JSON strings
      try {
        const parsed = JSON.parse(obj);
        return JSON.stringify(parsed, null, indent);
      } catch {
        return obj; // not JSON, return raw string
      }
    }

    if (typeof obj === "object" && obj !== null) {
      return JSON.stringify(
        obj,
        (key, value) => {
          if (typeof value === "string") {
            try {
              return JSON.parse(value);
            } catch {
              return value;
            }
          }
          return value;
        },
        indent
      );
    }

    return String(obj);
  };

  const renderNotification = (notification) => {
    if (!notification) return "N/A";

    const [firstLine] = notification.split("\n");

    const beforeMatch = notification.match(/Before:\s*(\{.*\})\s*After:/s);
    const afterMatch = notification.match(/After:\s*(\{.*\})/s);

    let beforeJson = null;
    let afterJson = null;

    try {
      if (beforeMatch) beforeJson = JSON.parse(beforeMatch[1]);
      if (afterMatch) afterJson = JSON.parse(afterMatch[1]);
    } catch (e) {
      console.error("Parse error", e);
    }

    return (
      <div style={{ fontFamily: "monospace", fontSize: "14px" }}>
        <div>{firstLine}</div>

        {beforeJson && (
          <div style={{ marginTop: "10px" }}>
            <strong>Before:</strong>
            <pre style={{ whiteSpace: "pre-wrap" }}>
              {prettyPrint(beforeJson, 2)}
            </pre>
          </div>
        )}

        {afterJson && (
          <div style={{ marginTop: "10px" }}>
            <strong>After:</strong>
            <pre style={{ whiteSpace: "pre-wrap" }}>
              {prettyPrint(afterJson, 2)}
            </pre>
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="container">
      <div className="show-breadcrumb pt-3">
        <div>
          <h5>Notifications</h5>
          <nav className="breadcrumb-nav" aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <a className=""> Notifications</a>
              </li>
            </ol>
          </nav>

          {/* User Dropdown Filter */}
          <div
            className="navbar-3 d-flex justify-content-between"
            style={{ marginTop: "-3px" }}
          >
            <div className="d-flex gap-3">
              <div className="search-container">
                <img src={search2} alt="Search" />
                <input
                  type="text"
                  className=""
                  id="search"
                  value={search}
                  onChange={(e) => {
                    setSearch(e.target.value);
                    setCurrentPage(1);
                  }}
                  placeholder="Search"
                  name="search"
                  autoComplete="off"
                />
              </div>
            </div>
            <div className="d-flex gap-3">
              <div className="dropdown">
                <select
                  id="users"
                  className="select-unit textarea"
                  value={selectedUserId}
                  onChange={(e) => handleUserSelect(e.target.value)}
                  style={{
                    width: "200px",
                    height: "calc(100% - 1px)",
                  }}
                >
                  <option value="">All Users</option>
                  {users.map((user) => (
                    <option key={user._id} value={user._id}>
                      {user?.name}
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <button
                  type="button"
                  id="openPopup"
                  className="btn-bg"
                  onClick={readAllNotifications}
                >
                  Read All
                </button>
              </div>
            </div>
          </div>
          {/* Notifications Table */}
          <div style={{ marginTop: "-10px" }}>
            <div className="table-responsive">
              <table className="table align-middle table-text">
                <thead className="table-head align-middle">
                  <tr>
                    <th className="col">ID</th>
                    <th onClick={() => handleSortChange("module_name")}>
                      MODULE
                      {sortBy.field === "module_name" && (
                        <span>
                          {sortBy.order === "asc" ? (
                            <img src={ArrowUp} alt="ArrowUp" />
                          ) : (
                            <img src={ArrowDown} alt="ArrowDown" />
                          )}
                        </span>
                      )}
                    </th>
                    <th onClick={() => handleSortChange("notification")}>
                      MESSAGE
                      {sortBy.field === "notification" && (
                        <span>
                          {sortBy.order === "asc" ? (
                            <img src={ArrowUp} alt="ArrowUp" />
                          ) : (
                            <img src={ArrowDown} alt="ArrowDown" />
                          )}
                        </span>
                      )}
                    </th>
                    <th onClick={() => handleSortChange("user_id")}>
                      UPDATED BY
                      {sortBy.field === "user_id" && (
                        <span>
                          {sortBy.order === "asc" ? (
                            <img src={ArrowUp} alt="ArrowUp" />
                          ) : (
                            <img src={ArrowDown} alt="ArrowDown" />
                          )}
                        </span>
                      )}
                    </th>
                    <th onClick={() => handleSortChange("date_time")}>
                      UPDATED AT
                      {sortBy.field === "date_time" && (
                        <span>
                          {sortBy.order === "asc" ? (
                            <img src={ArrowUp} alt="ArrowUp" />
                          ) : (
                            <img src={ArrowDown} alt="ArrowDown" />
                          )}
                        </span>
                      )}
                    </th>
                    <th>ACTION</th>
                  </tr>
                </thead>
                <tbody>
                  {notifications.map((notification) => (
                    <tr
                      key={notification._id}
                      className={notification.isUnread ? "" : "text-muted"}
                    >
                      <td>{notification.index}</td>
                      <td>{notification.module_name}</td>
                      <td
                      // style={{
                      //   whiteSpace: "normal",
                      //   wordWrap: "break-word",
                      //   maxWidth: "300px",
                      // }}
                      >
                        {notification.notification.split("\n")[0]}
                      </td>
                      <td>{notification.user_id}</td>
                      <td>{notification.date_time}</td>
                      <td>
                        <button
                          style={{ border: "none", background: "transparent" }}
                          onClick={() => handleViewClick(notification)}
                        >
                          <img src={eye} alt="view" />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
            pageSize={pageSize}
            onPageSizeChange={handlePageSizeChange}
            totalItems={totalItems}
            startIndex={startIndex}
            endIndex={endIndex}
          />
        </div>
      </div>

      {/* View Notification Modal */}
      <div
        id="overlay"
        className={`modal fade ${isModalOpen ? "show" : ""}`}
        tabIndex="-1"
        role="dialog"
        style={{ zIndex: 30, display: isModalOpen ? "block" : "none" }}
      >
        {loading ? (
          <Loader />
        ) : (
          <div>
            <div className="addunit-card" style={{ width: "50%" }}>
              <div className="addunit-header">
                <h4>View Notification</h4>
                <button
                  style={{ border: "none", backgroundColor: "inherit" }}
                  type="button"
                  className="close"
                  onClick={() => {
                    setIsModalOpen(false);
                    window.location.reload();
                  }}
                >
                  <img src={close} width="28px" height="28px" alt="Close" />
                </button>
              </div>
              <div
                className="addunit-form"
                style={{
                  maxHeight: "400px",
                  overflowY: "auto",
                  overflowX: "hidden",
                  padding: "15px",
                }}
              >
                <div className="d-flex flex-column mb-3">
                  <label
                    className="addunit-form-text"
                    style={{ color: "#333", fontWeight: "bold" }}
                  >
                    Module
                  </label>
                  <p>{selectedNotification?.module_name || "N/A"}</p>
                </div>
                <div className="d-flex flex-column mb-3">
                  <label
                    className="addunit-form-text"
                    style={{ color: "#333", fontWeight: "bold" }}
                  >
                    Message
                  </label>
                  <div>
                    {renderNotification(selectedNotification?.notification)}
                  </div>
                </div>
                <div className="d-flex flex-column mb-3">
                  <label
                    className="addunit-form-text"
                    style={{ color: "#333", fontWeight: "bold" }}
                  >
                    Updated By
                  </label>
                  <p>{selectedNotification?.user_id || "N/A"}</p>
                </div>
                <div className="d-flex flex-column mb-3">
                  <label
                    className="addunit-form-text"
                    style={{ color: "#333", fontWeight: "bold" }}
                  >
                    Updated At
                  </label>
                  <p>{selectedNotification?.date_time || "N/A"}</p>
                </div>
              </div>
              <div className="addunit-card-footer justify-content-between">
                <button
                  type="button"
                  className="discard-btn"
                  onClick={() => {
                    setIsModalOpen(false);
                    window.location.reload();
                  }}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
      <ToastContainer autoClose={4000} position={"top-right"} />
    </div>
  );
};

export default Notification;
